module.exports = __webpack_public_path__ + "static/media/date-grey.f94e419b.svg";